<template>
  <div>
    <div :class="$vuetify.breakpoint.lg ? ' mt-3 mb-7' : 'mb-5'" class="d-flex">
      <h1 v-if="$vuetify.breakpoint.lg" class="display-2">Live elections</h1>
    </div>

    <p v-if="false" class="my-10">
      👉 For Student Union Government (SUG) Elections
      <v-btn
        outlined
        rounded
        color="green"
        href="https://elections.uniuyo.edu.ng/"
        class="ml-1 my-3"
      >
        Click Here
      </v-btn>
    </p>

    <h2 v-if="elections.length == 0" class="red--text px-1">
      <p>{{ report }}</p>
    </h2>

    <div v-else>
      <v-row>
        <v-col cols="12" v-for="election in elections" :key="election.id">
          <ElectionCard :election="election" results />
        </v-col>
      </v-row>


      <!-- <v-switch
        class="mt-7"
        color="red accent-3"
        v-model="autoRefresh"
        label="Auto refresh (every 5 mins)"
      ></v-switch> -->
    </div>

    <v-btn
      fab
      fixed
      bottom
      right
      large
      class="white--text"
      v-if="elections.length > 0"
      color="red accent-3"
      @click="loadElections"
      :disabled="loading"
      :loading="loading"
    >
      <v-icon large>mdi-refresh-circle</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { timeago } from "../tools/format";
import ElectionCard from "./election/includes/ElectionCard";

export default {
  components: { ElectionCard },

  data: () => ({
    elections: [],
    report: null,
    loading: false,
    autoRefresh: false,
  }),

  computed: {
    electionDateReached() {
      const now = new Date().getTime();
      const sugDate = new Date("2022-12-06").getTime();

      return now >= sugDate;
    },
  },

  methods: {
    timeago,
    loadElections() {
      if (!this.loading) {
        this.loading = true;

        this.$axios
          .get("/live")
          .then(async ({ data: elections }) => {
            this.elections = elections;

            if (elections.length == 0) {
              this.report = "There are no live elections at this time.";
            }
          })
          .catch(() => {
            this.report =
              "Could not load live elections. Refresh this page to try again.";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // autoRefreshResults() {
    //   setInterval(() => {
    //     if (this.autoRefresh && !this.loading) {
    //       this.loadElections();
    //     }
    //   }, 300000);
    // },
  },

  mounted() {
    this.loadElections();
    // this.autoRefreshResults();
  },
};
</script>


<style>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
